import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import { PreviewDocumentTemplateQuery } from '@/gql/graphql';

const PREVIEW_DOCUMENT_TEMPLATE = graphql(`
  query PreviewDocumentTemplate($input: PreviewDocumentTemplateInput!) {
    previewDocumentTemplate(input: $input) {
      ... on DocumentTemplatePreviewSuccess {
        __typename
        preview
        usedVariables
      }
      ... on DocumentTemplatePreviewError {
        __typename
        message
      }
    }
  }
`);

type PreviewDocumentTemplateInput = {
  templateHtml: string;
};

const usePreviewDocumentTemplate = (
  options?: UseMutationOptions<
    PreviewDocumentTemplateQuery,
    Error,
    PreviewDocumentTemplateInput
  >
) => {
  return useMutation({
    mutationFn: (input: PreviewDocumentTemplateInput) => {
      return gqlClient
        .request(PREVIEW_DOCUMENT_TEMPLATE, {
          input: {
            templateHtml: input.templateHtml,
          },
        })
        .then((result) => {
          if (
            result.previewDocumentTemplate.__typename ===
            'DocumentTemplatePreviewError'
          ) {
            throw new Error(result.previewDocumentTemplate.message);
          } else {
            return result;
          }
        });
    },
    ...options,
  });
};

export default usePreviewDocumentTemplate;
